import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPassport: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconPassport"><Path fillRule="evenodd" clipRule="evenodd" d="M3.5 2.5H20.5V21.5H3.5V2.5ZM12 8.25C10.7574 8.25 9.75 9.25736 9.75 10.5C9.75 11.7426 10.7574 12.75 12 12.75C13.2426 12.75 14.25 11.7426 14.25 10.5C14.25 9.25736 13.2426 8.25 12 8.25ZM8.25 10.5C8.25 8.42893 9.92893 6.75 12 6.75C14.0711 6.75 15.75 8.42893 15.75 10.5C15.75 12.5711 14.0711 14.25 12 14.25C9.92893 14.25 8.25 12.5711 8.25 10.5ZM8.5 15.5H15.5V17H8.5V15.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPassport;
